/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface CustomerFeedbackFileApiModel {
  /**
   * File ID
   */
  id?: string;
  /**
   * File mime type
   */
  mime_type?: string;
  /**
   * File type
   */
  type?: CustomerFeedbackFileApiModelTypeEnum;
}
export enum CustomerFeedbackFileApiModelTypeEnum {
  Picture = 'picture',
  Voice = 'voice',
  Video = 'video'
}
